export default {
  list: {
    loading: false,
    error: {},
    data: [],
  },
}
